import I18njs from 'i18n-js';

import Button from 'carbon-react/lib/components/button';
import Loader from 'carbon-react/lib/components/loader';
import Textbox from 'carbon-react/lib/components/textbox';

import Translate from '../../components/Translate/Translate';

const FallbackMfaForm = ({ fallbackToken, handleFallbackMfaSubmit, loading, resend, setFallbackToken }) => {
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (fallbackToken) handleFallbackMfaSubmit();
    }
  };

  return (
    <>
      <div className="title">
        <Translate scope="auth.LogIn" />
      </div>
      <div className="subtitle">
        <Translate scope="auth.Wesentacodetoyouremail" markdown />
      </div>
      <div className="fs-exclude">
        <Textbox
          autoComplete="one-time-code"
          autoFocus
          label={I18njs.t('auth.Securitycode')}
          name="fallbackToken"
          onChange={(e) => setFallbackToken(e.target.value)}
          onKeyDown={onKeyDown}
          type="text"
          value={fallbackToken}
        />
      </div>
      <div className="submit-wrapper">
        <Button buttonType="tertiary" className="resend-button" onClick={resend} size="small">
          <Translate scope="auth.Resend" />
        </Button>
        <Button buttonType="primary" className="submit-button" disabled={!fallbackToken} onClick={handleFallbackMfaSubmit}>
          {loading ? <Loader isInsideButton /> : <Translate scope="auth.Submit" />}
        </Button>
      </div>
    </>
  );
};

export default FallbackMfaForm;
